export const defaultResultsFieldsMapping = JSON.stringify([
    { fldName: 'Str01', fldTitle: 'Επίδοση' },
    { fldName: 'Str02', fldTitle: 'Ποινές' },
    { fldName: 'Str03', fldTitle: 'Σύνολο' },
    { fldName: 'Str04', fldTitle: 'ΔΙΑΔΡΟΜΗ #1' },
    { fldName: 'Str05', fldTitle: 'ΔΙΑΔΡΟΜΗ #2' }
]);
